import { formatNumber } from "@/lib/format";

/** Documentos por coleção da raiz, no resumo de um ZIP. */
export function CollectionCounts({ perCollection }: { perCollection: Record<string, number> }) {
  const rows = Object.entries(perCollection).sort(([a], [b]) => a.localeCompare(b));
  if (rows.length === 0) return null;
  return (
    <ul className="mt-2 grid grid-cols-1 gap-x-4 gap-y-1 xs:grid-cols-2">
      {rows.map(([name, count]) => (
        <li key={name} className="flex min-w-0 justify-between gap-2 text-caption">
          <span className="truncate font-mono">{name}</span>
          <span className="shrink-0 tabular-nums text-muted-foreground">{formatNumber(count)}</span>
        </li>
      ))}
    </ul>
  );
}
